<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BFormInput
            id="filterSearch"
            v-model="tableOfficers.filter.search"
            placeholder="search here"
            autocomplete="off"
            debounce="1000"
            type="text"
          />
        </BFormGroup>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableOfficers"
      :provider="tableProvider"
      :fields="tableOfficers.fields"
      :filter="tableOfficers.filter"
      :filter-on="tableOfficers.filterOn"
      :sort-by="tableOfficers.sortBy"
      :sort-desc="tableOfficers.sortDesc"
      :sort-direction="tableOfficers.sortDirection"
      :total-rows="tableOfficers.totalRows"
      :current-page="tableOfficers.currentPage"
      :per-page="tableOfficers.perPage"
      :stacked="tableOfficers.stacked"
      :busy="tableOfficers.busy"
    >
      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center gap-2">
          <!-- <BButton
            size="sm"
            variant="primary"
            :to="{
              name: 'asm.officers.profile',
              params: {
                officer: item.id
              }
            }"
          >
            View
          </BButton> -->
          <BButton
            size="sm"
            variant="primary"
            :to="{
              name: 'asm.tracking.officer-tasks',
              params: {
                officer: item.id
              }
            }"
          >
            Tasks
          </BButton>
        </div>
      </template>

    </CustomTable>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { SASMFso } from '@/services/asm'

export default {

  name: 'VASMOfficerEmployees',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth',
    'asm'
  ],

  metaInfo: () => ({
    title: 'Employees'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      formOfficer: {
        id: null,
        role_id: null,
        username: null,
        first_name: null,
        last_name: null,
        email: null,
        notification_email: null,
        mobile_number: null,
        clusters: []
      },
      tableOfficers: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          // { mobile: 4, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'name', label: 'Name', class: 'min-w-md-350px', formatter: this.getFullName, sortable: true },
          { mobile: 3, key: 'created_at', class: 'min-w-175px', formatter: this.dateTimeShortFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  }),

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableOfficers.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        area_id: this.currentUser.area
      }

      return await SASMFso.get(payload).then(
        ({ data }) => {
          this.tableOfficers.totalRows = data.total_rows
          return data.items
        }
      ).catch(() => {
        this.tableOfficers.totalRows = 0
        return []
      }).finally(() => {
        this.tableOfficers.busy = false
      })
    }
  }
}
</script>
